import React from "react";
import "../../CSS/Industries.css";

function Professional() {
    return (
        <>
           
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">

                    <div className="industry-detail-hero-content">



                        <h1>
                            Solutions for Professional Services
                        </h1>

                        <p style={{ color: '#FF7D37' }}>
                            Help professional service businesses improve
                            client management, workflows, communication,
                            reporting, and daily operations.
                        </p>

                    </div>

                </div>
            </section>


            <section className="industry-detail-section">

                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Digital Solutions Built Around Your Business
                            </h2>

                            <p>
                                Professional service organizations need
                                technology that helps teams manage projects,
                                clients, documents, and business operations.
                            </p>

                            <p>
                                We build customized software and web solutions
                                designed around your organization's workflows.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/professional.png"
                                alt="Professional Services Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>

            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for <br />Professional Services</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-people"></i>
                            <h3>Client Management</h3>
                            <p>Systems to organize customer and client information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-kanban"></i>
                            <h3>Project Management</h3>
                            <p>Solutions to manage projects, tasks, and workflows.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-file-earmark"></i>
                            <h3>Document Management</h3>
                            <p>Organize business documents and information digitally.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-speedometer2"></i>
                            <h3>Business Dashboards</h3>
                            <p>Useful dashboards for business visibility and reporting.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Professional;